module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_c/main_sp_2fd5a4fcf96da874f290ef5c33863e36.jpg";